import { render } from "./ReportIssueView.vue?vue&type=template&id=48f278d3&scoped=true"
import script from "./ReportIssueView.vue?vue&type=script&lang=js"
export * from "./ReportIssueView.vue?vue&type=script&lang=js"

import "./ReportIssueView.vue?vue&type=style&index=0&id=48f278d3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48f278d3"]])

export default __exports__